<template>
  <div style="padding:10px;">
    <h1>{{ $t("settings.header") }}</h1>
    <v-layout wrap row style="margin:0;">
      <v-flex sm4>
        <v-card style="margin:5px;" outlined>
          <v-card-title>{{ $t("settings.profile") }}</v-card-title>
          <v-card-text>{{ profile.email }}</v-card-text>
          <v-card-actions>
            <v-btn color="error" @click="logout" text>{{ $t("settings.sign_out") }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex sm4>
        <v-form @submit="changePassword">
          <v-card style="margin:5px;" outlined>
            <v-card-title>{{ $t("settings.change_password") }}</v-card-title>
            <v-card-text>
              <v-text-field
                type="password"
                :label="$t('settings.current_password')"
                v-model="changepassword_current"
              ></v-text-field>
              <v-text-field type="password" :label="$t('settings.new_password')" v-model="changepassword_new"></v-text-field>
              <v-text-field
                type="password"
                :label="$t('settings.repeat_new_password')"
                v-model="changepassword_new_repeat"
              ></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-btn color="default" type="submit" text>{{ $t("settings.change") }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-flex>
      <v-flex sm4>
        <v-card outlined style="margin:5px;">
          <v-card-title>{{ $t("settings.language") }}</v-card-title>
          <v-card-text>
            <v-select
              @change="onLanguageChange"
              v-model="language"
              :items="[{text: 'Deutsch', value: 'de'}, {text: 'English', value: 'en'}]"
            ></v-select>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <br />
    <h3>{{ $t("settings.notifications") }}</h3>
    <v-switch
      @change="toggleNotification"
      :label="$t('settings.turn_on_notifications')"
      v-model="notification_setting"
    ></v-switch>
    <p>{{ $t("settings.test_notification_description") }}</p>
    <v-btn @click="testNotification">{{ $t("settings.send_test_notification") }}</v-btn>
    <br />
    <br />
    <h3>{{ $t("settings.devices") }}</h3>
    <p>{{ $t("settings.devices_description") }}</p>
    <v-layout row wrap style="margin:0;">
      <v-flex xs6 sm4 md3 lg2 v-for="session in sessions" :key="session.id">
        <SessionCard @sessiondeleted="loadActiveSessions" :session="session"></SessionCard>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { auth, s_messaging } from "../schmucklicloud";
import { Notifications, PushNotification } from "../notification";

import SessionCard from "../components/SessionCard";

export default {
  data() {
    return {
      profile: {
        email: ""
      },
      language: window.localStorage.getItem("lang") || "en",
      sessions: [],
      notification_setting:
        window.localStorage.getItem("notification") === "true" ? true : false,

      changepassword_current: "",
      changepassword_new: "",
      changepassword_new_repeat: ""
    };
  },
  mounted() {
    this.getProfileInformation();
    this.loadActiveSessions();
  },
  methods: {
    async getProfileInformation() {
      var session_token = localStorage.getItem("session_token");
      var response = await auth.getUserDetails(session_token);
      if (response.isOK) {
        this.profile = response.data;
      }
    },
    async loadActiveSessions() {
      var session_token = localStorage.getItem("session_token");
      var response = await auth.getActiveSessions(session_token);
      if (response.isOK) {
        this.sessions = response.data;
      }
    },
    async logout() {
      var session_token = localStorage.getItem("session_token");
      var response = await auth.logout(session_token);
      if (response.isOK) {
        localStorage.removeItem("session_token");
        Notifications.show("Logout successful.");
        this.$router.replace("/login");
      } else {
        Notifications.show("There was an error while trying to logout.");
      }
    },
    onLanguageChange() {
      window.localStorage.setItem("lang", this.language);
      this.$root.$i18n.locale = this.language;
    },
    async toggleNotification() {
      if (this.notification_setting) {
        await PushNotification.turnOn();
      } else {
        await PushNotification.turnOff();
      }
    },
    //Sends a test notification.
    async testNotification() {
      var response = await s_messaging.sendRequestNow(
        JSON.stringify({
          notification: {
            title: "Test notification",
            description: "This is a test notification for all your devices."
          }
        })
      );

      if (response.status === 200) {
        Notifications.show("The notification has been sent.");
      } else {
        Notifications.show(
          "There was an error while trying to send the notifications."
        );
      }
    },
    async changePassword(e) {
      e.preventDefault();

      if (this.changepassword_new === this.changepassword_new_repeat) {
        var response = await auth.updatePassword(
          this.profile.email,
          this.changepassword_current,
          this.changepassword_new
        );
        if (response.isOK) {
          Notifications.show("The password has been changed.");
          this.changepassword_current = "";
          this.changepassword_new = "";
          this.changepassword_new_repeat = "";
        } else {
          Notifications.show(response.message);
        }
      }
    }
  },
  components: {
    SessionCard
  }
};
</script>

<style>
</style>